(function () {
  'use strict';

  var $ = function(sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); };

  var root = $('.esp01');
  if (!root) return;

  var PREFIJO_SKU = root.dataset.prefijoSku || 'ESP_01';
  var WA_NUMERO = root.dataset.whatsappNumero;
  var PRODUCT_TITLE = $('.esp01__titulo').textContent.trim();

  var state = {
    variantes: [],
    seleccion: {
      alto: null,
      ancho: null,
      fondo: null,
      niveles: null,
      ensamble: 'Soldada',
      modulo: 'No',
      tendido: 'normal'
    },
    cantidad: 1
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    state.variantes = window.ESP01_VARIANTES || [];
    bindEventos();
    seleccionPorDefecto();
    actualizar();
  }

  function buscarVariante(ref) {
    for (var i = 0; i < state.variantes.length; i++) {
      if (state.variantes[i].sku === ref) {
        return state.variantes[i];
      }
    }
    return null;
  }

 function getPrecio(variante) {
    var p = variante.price;
    if (typeof p === 'string') p = parseFloat(p);
    return p / 100;
  }

  function bindEventos() {
    // Click en cualquier pill (alto, ancho, fondo, niveles, ensamble, modulo)
    root.addEventListener('click', function(e) {
      var pill = e.target.closest('.esp01__pill');
      if (pill && !pill.classList.contains('is-disabled')) {
        var dim = pill.dataset.dim;
        var valor = pill.dataset.valor;
        if (['alto', 'ancho', 'fondo', 'niveles'].indexOf(dim) !== -1) {
          state.seleccion[dim] = parseInt(valor, 10);
        } else {
          state.seleccion[dim] = valor;
        }
        actualizar();
      }
    });

    // El tendido ahora es pill, se maneja por el listener general de pills

    // Botones cantidad
    $$('.esp01__cantidad-btn').forEach(function(b) {
      b.addEventListener('click', function(e) {
        var input = $('#esp01-cantidad');
        var v = parseInt(input.value, 10) || 1;
        v += (e.target.dataset.action === 'mas' ? 1 : -1);
        v = Math.max(1, Math.min(99, v));
        input.value = v;
        state.cantidad = v;
        actualizar();
      });
    });

    $('#esp01-cantidad').addEventListener('change', function(e) {
      state.cantidad = Math.max(1, parseInt(e.target.value, 10) || 1);
      e.target.value = state.cantidad;
      actualizar();
    });

    // Thumbnails
    $$('.esp01__thumb').forEach(function(t) {
      t.addEventListener('click', function() {
        $$('.esp01__thumb').forEach(function(x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        $('#esp01-render').src = t.dataset.image;
      });
    });

    $('#esp01-comprar').addEventListener('click', onComprarClick);
    $('#esp01-asesor').addEventListener('click', onAsesorClick);
  }

  function seleccionPorDefecto() {
    // Preferencia: iniciar en una combinacion con precio cargado
    // Si no existe, usar la primera variante disponible o primer valor del DOM
    var variantePreferida = buscarVariante(PREFIJO_SKU + '_240_240_100_3');

    if (variantePreferida) {
      state.seleccion.alto = 240;
      state.seleccion.ancho = 240;
      state.seleccion.fondo = 100;
      state.seleccion.niveles = 3;
    } else if (state.variantes && state.variantes.length > 0) {
      // Buscar primera variante con SKU valido del producto
      var primera = null;
      for (var i = 0; i < state.variantes.length; i++) {
        if (state.variantes[i].sku && state.variantes[i].sku.indexOf(PREFIJO_SKU + '_') === 0) {
          primera = state.variantes[i];
          break;
        }
      }
      if (primera) {
        var partes = primera.sku.split('_');
        // SKU formato: ESP_01_ALTO_ANCHO_FONDO_NIVELES (indices 2,3,4,5)
        if (partes.length >= 6) {
          state.seleccion.alto = parseInt(partes[2], 10);
          state.seleccion.ancho = parseInt(partes[3], 10);
          state.seleccion.fondo = parseInt(partes[4], 10);
          state.seleccion.niveles = parseInt(partes[5], 10);
        }
      }
    } else {
      // Sin variantes: primer valor del DOM
      ['alto', 'ancho', 'fondo', 'niveles'].forEach(function(dim) {
        var primer = $('.esp01__pill[data-dim="' + dim + '"]');
        if (primer) {
          state.seleccion[dim] = parseInt(primer.dataset.valor, 10);
        }
      });
    }

    state.seleccion.ensamble = 'Soldada';
    state.seleccion.modulo = 'No';
    state.seleccion.tendido = 'normal';
  }

  // Regla central: forzar WhatsApp
  function requiereCotizacion() {
    return state.seleccion.modulo === 'Si';
  }

  function actualizar() {
    // Marcar pills activos
    ['alto', 'ancho', 'fondo', 'niveles', 'ensamble', 'modulo', 'tendido'].forEach(function(dim) {
      $$('.esp01__pill[data-dim="' + dim + '"]').forEach(function(p) {
        var valor = p.dataset.valor;
        var esNumerico = ['alto', 'ancho', 'fondo', 'niveles'].indexOf(dim) !== -1;
        var match = esNumerico ? parseInt(valor, 10) === state.seleccion[dim] : valor === state.seleccion[dim];
        p.classList.toggle('is-active', match);
      });
    });

    var ref = construirRef();
    $('#esp01-ref').textContent = ref;

    if (requiereCotizacion()) {
      modoCotizar();
    } else {
      var variante = buscarVariante(ref);
      if (variante) {
        modoComprar(variante);
      } else {
        modoCotizar();
      }
    }

    actualizarCargaTotal();
    cambiarImagenPorNiveles(state.seleccion.niveles);
  }

  function cambiarImagenPorNiveles(niveles) {
    var container = document.getElementById('esp01-niveles-images');
    if (!container) return;
    var renderEl = document.getElementById('esp01-render');
    var esEstibas = state.seleccion.tendido === 'estibas';

    // 1. Match exacto: niveles-N-estibas o niveles-N
    var targetAlt;
    if (esEstibas) {
      targetAlt = 'niveles-' + niveles + '-estibas';
    } else {
      targetAlt = 'niveles-' + niveles;
    }
    var imgExacto = container.querySelector('img[data-niveles="' + targetAlt + '"]');
    if (imgExacto) {
      renderEl.src = imgExacto.src;
      return;
    }

    // 2. Fallback 1: si esta en estibas y no hay imagen estibas, mostrar la normal
    if (esEstibas) {
      var imgNormal = container.querySelector('img[data-niveles="niveles-' + niveles + '"]');
      if (imgNormal) {
        renderEl.src = imgNormal.src;
        return;
      }
    }

    // 3. Fallback 2: primera imagen con esos niveles (cualquier sufijo)
    var todasImagenes = container.querySelectorAll('img[data-niveles]');
    for (var j = 0; j < todasImagenes.length; j++) {
      var alt = todasImagenes[j].getAttribute('data-niveles');
      if (alt && alt.indexOf('niveles-' + niveles) === 0) {
        renderEl.src = todasImagenes[j].src;
        return;
      }
    }

    // 4. Ultimo fallback: primera imagen disponible
    var primera = container.querySelector('img[data-niveles]');
    if (primera) {
      renderEl.src = primera.src;
    }
  }

  function construirRef() {
    var s = state.seleccion;
    var base = PREFIJO_SKU + '_' + s.alto + '_' + s.ancho + '_' + s.fondo + '_' + s.niveles;
    if (s.tendido === 'estibas') {
      base = base + '_Para_Estibas';
    }
    return base;
  }

  function actualizarCargaTotal() {
    var cargaPorNivel = parseInt($('#esp01-carga-nivel').textContent, 10) || 0;
    if (cargaPorNivel > 0) {
      $('#esp01-carga-total').textContent = (cargaPorNivel * state.seleccion.niveles) + ' kg';
    }
  }

  function modoComprar(variante) {
    var precio = getPrecio(variante);
    var total = precio * state.cantidad;
    $('#esp01-precio').textContent = formatearPrecio(total);
    $('#esp01-precio').classList.remove('is-cotizar');
    $('.esp01__precio-iva').style.display = '';
    $('#esp01-mensaje-cotizar').hidden = true;
    $('#esp01-cantidad-wrapper').hidden = false;
    $('#esp01-comprar-texto').textContent = $('#esp01-comprar-texto').getAttribute('data-default') || 'Comprar';
    $('#esp01-comprar').classList.remove('esp01__btn--cotizar');
    $('#esp01-comprar').disabled = false;
  }

  function modoCotizar() {
    $('#esp01-precio').textContent = 'Cotización personalizada';
    $('#esp01-precio').classList.add('is-cotizar');
    $('.esp01__precio-iva').style.display = 'none';
    $('#esp01-mensaje-cotizar').hidden = false;
    $('#esp01-cantidad-wrapper').hidden = true;
    $('#esp01-comprar-texto').textContent = 'Solicitar cotización';
    $('#esp01-comprar').classList.add('esp01__btn--cotizar');
    $('#esp01-comprar').disabled = false;
  }

  function onComprarClick() {
    if (requiereCotizacion()) {
      abrirWhatsApp(construirRef(), 'cotizacion');
      return;
    }
    var ref = construirRef();
    var variante = buscarVariante(ref);
    if (variante) {
      agregarAlCarrito(ref, variante);
    } else {
      abrirWhatsApp(ref, 'cotizacion');
    }
  }

  function onAsesorClick() {
    abrirWhatsApp(construirRef(), 'asesor');
  }

  function agregarAlCarrito(ref, variante) {
    var btn = $('#esp01-comprar');
    var textoOriginal = $('#esp01-comprar-texto').textContent;
    btn.disabled = true;
    $('#esp01-comprar-texto').textContent = 'Agregando...';
    var s = state.seleccion;
    var properties = {
      'Alto': s.alto + ' cm',
      'Ancho': s.ancho + ' cm',
      'Profundidad': s.fondo + ' cm',
      'Niveles': s.niveles,
      'Tipo de ensamble': s.ensamble,
      'Módulo adicional': s.modulo === 'Si' ? 'Sí' : 'No',
      'Tendido': s.tendido === 'normal' ? 'Tendido normal' : 'Para estibas'
    };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variante.id, quantity: state.cantidad, properties: properties }]
      })
    })
    .then(function(resp) {
      if (!resp.ok) throw new Error('Error');
      window.location.href = '/cart';
    })
    .catch(function() {
      alert('No pudimos agregar el producto al carrito. Por favor intenta de nuevo o contáctanos por WhatsApp.');
      btn.disabled = false;
      $('#esp01-comprar-texto').textContent = textoOriginal;
    });
  }

  function abrirWhatsApp(ref, tipo) {
    var s = state.seleccion;
    var tendidoLabel = s.tendido === 'normal' ? 'Tendido normal' : 'Para estibas';
    var moduloLabel = s.modulo === 'Si' ? 'Sí' : 'No';
    var variante = buscarVariante(ref);
    var mensaje;

    if (tipo === 'cotizacion') {
      mensaje = 'Hola Maiko, quiero cotizar una estantería personalizada:\n\n' +
                'Producto: ' + PRODUCT_TITLE + '\n' +
                'Referencia: ' + ref + '\n' +
                'Alto: ' + s.alto + ' cm\n' +
                'Ancho: ' + s.ancho + ' cm\n' +
                'Profundidad: ' + s.fondo + ' cm\n' +
                'Niveles: ' + s.niveles + '\n' +
                'Tipo de ensamble: ' + s.ensamble + '\n' +
                'Módulo adicional: ' + moduloLabel + '\n' +
                'Tendido: ' + tendidoLabel + '\n\n' +
                'Quedo atento a la cotización, gracias.';
    } else {
      var precioInfo = variante && !requiereCotizacion() ?
        '\nPrecio web: ' + formatearPrecio(getPrecio(variante)) :
        '\nCotización: personalizada';
      mensaje = 'Hola Maiko, quiero hablar con un asesor sobre:\n\n' +
                'Producto: ' + PRODUCT_TITLE + '\n' +
                'Referencia: ' + ref + '\n' +
                s.alto + 'x' + s.ancho + 'x' + s.fondo + ' cm - ' + s.niveles + ' niveles\n' +
                'Ensamble: ' + s.ensamble + '\n' +
                'Módulo adicional: ' + moduloLabel + '\n' +
                'Tendido: ' + tendidoLabel + precioInfo;
    }
    window.open('https://wa.me/' + WA_NUMERO + '?text=' + encodeURIComponent(mensaje), '_blank', 'noopener');
  }

  function formatearPrecio(valor) {
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(valor);
  }

})();
